const appConfig = {
    apiPrefix: '/api',
    authenticatedEntryPath: '/dashboard',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/app/account/kyc-form',
    locale: 'en',
    enableMock: false,
    sellerDashboardUrl: 'https://dashboard.shipclues.in/admin/',
}
    
export default appConfig

